import { ClientActivityQueryParams, ClientTaskQueryParams } from '../model/client.model';
import { ActivityQueryParams, TaskQueryParams } from '../model/dashboard.model';

export class HuddleApiConstants {
  public static readonly DASHBOARD_API = {
    GET_DEAL: {
      URL: () => `sf/get_rollup_nums`,
    },
    GET_TASKS: {
      URL: () => `/huddle/sf/get_tasks?`,
      QUERY_PARAMS: (queryParams?: TaskQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_ACTIVITY: {
      URL: () => `/huddle/sf/recent_activity?`,
      QUERY_PARAMS: (queryParams?: ActivityQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_CLIENT: {
      URL: () => `sf/client_filter_values`,
    },
    GET_ACTION_ACCOUNT: {
      URL: () => `sf/actionable_accounts`,
    },
    GET_DROPDOWN: {
      URL: (email: string) => `/huddle/sf/task_dropdowns?mailId=${email}`,
    },

    HUDDLE_TASK: {
      URL: () => `/huddle/sf/task`,
    },
    EDIT_HUDDLE_TASK: {
      URL: (code: string) => `/huddle/sf/task/${code}`,
    },
    DELETE_HUDDLE_TASK: {
      URL: (code: string) => `/huddle/sf/task/${code}`,
    },
  };
  public static readonly CLIENT_API = {
    ALL_CLIENT: {
      URL: () => `/huddle/clients/all_clients`,
    },
    ADD_CLIENT: {
      URL: () => `/huddle/clients/client`,
    },
    DELETE_EDIT_CLIENT: {
      URL: (id: string) => `/huddle/clients/client/${id}`,
    },
    CLIENT_DETAILS: {
      URL: (id: string) => `/huddle/clients/client_profile_details?accountId=${id}`,
    },
    CLIENT_DROPDOWNS: {
      URL: (id: string) => `/huddle/clients/client_dropdowns?clientType=${id}`,
    },
    CLIENT_KEY_DEALS: {
      URL: (id: string) => `/huddle/clients/key_deals?accountId=${id}&`,
      QUERY_PARAMS: (queryParams?: any): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    ADD_DEAL: {
      URL: () => `/huddle/clients/deal`,
    },
    EDIT_DEAL: {
      URL: (id: string) => `/huddle/clients/deal/${id}`,
    },
    ALL_PRICEBOOKS: {
      URL: () => `/huddle/clients/pricebooks`,
    },
    PRICEBOOK_PRODUCTS: {
      URL: (id: string) => `/huddle/clients/pricebook/${id}/products`,
    },
    DEAL_DROPDOWN: {
      URL: (id?: string) => `/huddle/clients/deal_dropdowns?${id ? '?id=' + id : ''}`,
    },
    CREATE_PRICEBOOK_PRODUCTS: {
      URL: () => `/huddle/clients/opplineitems/`,
    },
    EDIT_PRICEBOOK_PRODUCTS: {
      URL: (id: string) => `/huddle/clients/opplineitems/${id}`,
    },
    CLIENT_DEAL: {
      URL: (id: string) => `clients/client_rollup_nums?accountId=${id}`,
    },
    CLIENT_ACTIVITY: {
      URL: (id: string) => `/huddle/clients/client_activity?accountId=${id}&`,
      QUERY_PARAMS: (queryParams?: ClientActivityQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_TASKS: {
      URL: (id: string) => `/huddle/clients/client_tasks?accountId=${id}&`,
      QUERY_PARAMS: (queryParams?: ClientTaskQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_CONTACTS: {
      URL: (id: string) => `/huddle/clients/client_contacts?accountId=${id}`,
    },
    POST_CONTACT: {
      URL: () => `/huddle/clients/contact`,
    },
    UPDATE_CONTACT: {
      URL: (id: string) => `/huddle/clients/contact/${id}`,
    },
    DELETE_CONTACT: {
      URL: (id: string) => `/huddle/clients/contact/${id}`,
    },
    POST_CLIENT_EVENT: {
      URL: (clientId: string) => `/clients/${clientId}/calendar/events`,
    },
    GET_CLIENT_EVENTS: {
      URL: (clientId: string) => `/clients/${clientId}/calendar/events`,
    },
    GET_CLIENT_EVENT_BY_ID: {
      URL: (clientId: string, eventId: string) => `/clients/${clientId}/calendar/events/${eventId}`,
    },
    EDIT_CLIENT_EVENT: {
      URL: (clientId: string, eventId: string) => `/clients/${clientId}/calendar/events/${eventId}`,
    },
    DELETE_CLIENT_EVENT: {
      URL: (clientId: string, eventId: string) => `/clients/${clientId}/calendar/events/${eventId}`,
    },
    POST_USER_EVENT: {
      URL: () => `/clients/my/calendar/events`,
    },
    GET_USER_EVENTS: {
      URL: () => `/clients/my/calendar/events`,
    },
    GET_USER_EVENT_BY_ID: {
      URL: (eventId: string) => `/clients/my/calendar/events/${eventId}`,
    },
    EDIT_USER_EVENT: {
      URL: (eventId: string) => `/clients/my/calendar/events/${eventId}`,
    },
    DELETE_USER_EVENT: {
      URL: (eventId: string) => `/clients/my/calendar/events/${eventId}`,
    },
  };
  public static readonly NOTES_API = {
    ALL_NOTES: {
      URL: (id: string) => `huddle/sf/notes/${id}?`,
      QUERY_PARAMS: (queryParams?: { access_token: string }): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    ADD_EDIT_NOTES: {
      URL: () => `huddle/sf/notes`,
    },
    DELETE_NOTES: {},
  };
  public static readonly TASKS_API = {
    GET_TASK_DROPDOWNS: {
      URL: () => `/tasks/task_dropdowns`,
    },
    GET_TASK_BY_ID: { URL: (taskId: string) => `/tasks/task/${taskId}` },
    GET_CLIENT_FILTER_VALUES: {
      URL: () => `/tasks/client_filter_values`,
    },
    CREATE_TASK: {
      URL: () => `/tasks/task`,
    },
    UPDATE_TASK: {
      URL: (taskId: string) => `/tasks/task/${taskId}`,
    },
    DELETE_TASK: {
      URL: (taskId: string) => `/tasks/task/${taskId}`,
    },
    GET_KANBAN: {
      URL: () => `/tasks/kanban`,
      QUERY_PARAMS: (queryParams?: Record<string, string | number | boolean>): string => {
        if (!queryParams) return '';
        const validParams = Object.entries(queryParams).filter(
          ([_, value]) => value != null && value !== '',
        );
        return validParams
          .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
          .join('&');
      },
    },
    GET_LIST_VIEW: {
      URL: () => `/tasks/list_view`,
      QUERY_PARAMS: (queryParams?: Record<string, string | number | boolean>): string => {
        if (!queryParams) return '';
        const validParams = Object.entries(queryParams).filter(
          ([_, value]) => value != null && value !== '',
        );
        return validParams
          .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
          .join('&');
      },
    },
    GET_ROLLUP_NUMBERS: {
      URL: () => `/tasks/rollup_numbers`,
      QUERY_PARAMS: (queryParams?: { mine?: boolean }): string => {
        if (!queryParams) return '';
        const validParams = Object.entries(queryParams).filter(
          ([_, value]) => value != null && value !== false,
        );
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_PRESIGNED_URL: {
      URL: () => `/tasks/get_presigned_url`,
      QUERY_PARAMS: (queryParams: {
        mailId: string;
        key: string;
        contentType: string;
        expires?: number;
      }): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );
        return validParams
          .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
          .join('&');
      },
    },
  };
}
